import { Goal } from './goal';
import { ID } from './id';
import { LifeArea } from './life-area';

export { TimelineTimeframes } from './timeline-timeframes';

export enum TimelineScrollAnchor {
  TimeframeStart = 'timeframe-start',
  Today = 'today',
}

// id increments per navigation so an unchanged target still re-scrolls (today after a manual scroll-away)
export type TimelineScrollRequest = {
  anchor: TimelineScrollAnchor;
  id: number;
};

export type TimelineSubCategory = {
  id: ID;
  goal: Goal;
  subCategories: TimelineSubCategory[];
};

export type TimelineCategory = {
  id: ID;
  subCategories: TimelineSubCategory[];
  lifeArea: LifeArea;
  hideHeader?: boolean;
};

export enum TimelineDropSlotKinds {
  Line = 'line',
  Nest = 'nest',
}

export enum TimelineDropTargetKinds {
  Category = 'category',
  Goal = 'goal',
}

// Line inserts at insertIndex among the target's children; Nest makes the dragged goal its first child
export type TimelineDropSlot = {
  kind: TimelineDropSlotKinds;
  targetKind: TimelineDropTargetKinds;
  targetId: ID;
  categoryId: ID;
  insertIndex: number;
  top: number;
  depth: number;
};
